var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"password-category text--primary",attrs:{"to":_vm.to}},[_c('h3',[_c('v-icon',{attrs:{"color":_vm.color || 'primary',"large":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }